import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getAccessRows = store => store[NAME].accessRows;
export const getGroups = store => store[NAME].groups;
export const getAccessMap = store => store[NAME].accessMap;
export const getUsers = store => store[NAME].users;